import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SystemLogViewer from "../components/Admin/SystemLogViewer";
import AnomalyDetectionPanel from "../components/Admin/AnomalyDetectionPanel";
import ThreatPredictionPanel from "../components/Admin/ThreatPredictionPanel";

const AdminSecurityPage = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const token =
            localStorage.getItem("authToken") ||
            sessionStorage.getItem("authToken") ||
            localStorage.getItem("token") ||
            sessionStorage.getItem("token");

        const role =
            localStorage.getItem("role") ||
            sessionStorage.getItem("role");

        // 🔐 AUTH CHECK
        if (!token) {
            navigate("/login");
            return;
        }

        // 🔐 ROLE CHECK
        const normalizedRole = String(role || "").toLowerCase();

        if (!["admin", "administrator"].includes(normalizedRole)) {
            setError("Access denied. Admins only.");
            setLoading(false);
            return;
        }

        // 🔄 simulate loading or preload APIs
        const load = async () => {
            try {
                // you can add here:
                // await Promise.all([loadLogs(), loadAnomalies(), loadPredictions()]);
                setLoading(false);
            } catch (e) {
                console.error(e);
                setError("Failed to load security data.");
                setLoading(false);
            }
        };

        load();
    }, [navigate]);

    if (loading)
        return (
            <div className="p-6 text-gray-600">
                Loading security dashboard...
            </div>
        );

    if (error)
        return (
            <div className="p-6 text-red-500 font-medium">
                {error}
            </div>
        );

    return (
        <div className="p-6 max-w-6xl mx-auto">
            <h1 className="text-2xl font-bold mb-6">
                🛡️ Admin Security Dashboard
            </h1>

            <div className="space-y-8">

                {/* =========================
                   SYSTEM LOGS
                ========================= */}
                <section className="bg-white p-4 rounded shadow">
                    <h2 className="text-xl font-semibold mb-4">
                        System Logs
                    </h2>
                    <SystemLogViewer />
                </section>

                {/* =========================
                   ANOMALY DETECTION
                ========================= */}
                <section className="bg-white p-4 rounded shadow">
                    <h2 className="text-xl font-semibold mb-4">
                        Anomaly Detection
                    </h2>
                    <AnomalyDetectionPanel />
                </section>

                {/* =========================
                   THREAT PREDICTION
                ========================= */}
                <section className="bg-white p-4 rounded shadow">
                    <h2 className="text-xl font-semibold mb-4">
                        Threat Prediction
                    </h2>
                    <ThreatPredictionPanel />
                </section>

            </div>
        </div>
    );
};

export default AdminSecurityPage;